<template>
  <card class="relative">
    <div
      v-if="loading"
      class="rounded-lg flex items-center justify-center absolute inset-0 z-10"
      :class="modeClass"
    >
      <loader class="text-60" />
    </div>

    <slot></slot>
  </card>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      mode: {
        type: String,
        default: 'light',
        validator(value) {
          return ['light', 'dark'].indexOf(value) !== -1;
        },
      },
    },
    computed: {
      modeClass() {
        return this.mode === 'light' ? 'bg-white' : 'bg-90';
      },
    },
  };
</script>
